export enum DeliveryStatuses {
    Requested = 1,
    Confirmed = 2,
    ReadyForCheckIn = 3,
    CheckedIn = 4,
}
